/**
 * @namespace
 */
import axios from 'axios'
let project = {};


/**
 *获取项目列表
 *
 * @param {Object} params
 * @param params.team_id  团队ID
 * @param params.group_id  分组ID
 * @param params.brief  '0' or '1', '0' 表示非简洁，'1' 表示简洁（简洁只包含项目ID和名字）
 * @param params.time_order  desc asc
 * @param params.pageNo  1
 * @param params.pageSize  20
 * @returns {Object}
 */

project.getProjects = async function(params){
    let url = '/account/user_projects',
        data = params;
    try{
        let res = await axios.get(url,{
            params:data
        });
        return res;
    }catch(err){
        console.log(err);
    }

    return null;

}


/**
 *获取项目信息
 *
 * @param {Object} params
 * @param params.pid 团队id
 * @param params.members 表示返回项目成员，填'1'即可，不填则不返回成员信息
 * @returns {Object}
 */

project.getProjectInfo = async function(params){
    let url = '/project/project_info',
        data = params;
    try{
        let res = await axios.get(url,{
            params:data
        });
        return res;
    }catch(err){
        console.log(err);
    }

    return null;
}

/**
 *获取分区
 *
 * @param project_id
 * @returns {Object}
 */
project.getSectors = async function(project_id){
    let url = '/project/project_sectors',
        data = {project_id};

    try{
        let res = await axios.get(url,{
            params:data
        });
        return res;
    }catch(err){
        console.log(err);
    }

    return null;
}


/**
 *搜索图片
 *
 * @param team_id
 * @param pid
 * @param keyword
 * @returns {Object}
 */

project.searchImages = async function(team_id,pid,keyword){
    let url = '/project/search_image',
        data = {
            team_id,
            pid,
            keyword
        };

    try{
        let res = await axios.get(url,{
            params:data
        });
        return res;
    }catch(err){
        console.log(err);
    }

    return null;
}


/**
 *获取项目成员基础信息
 *
 * @param project_id
 * @returns
 */
project.getProjectUsernames = async function(project_id){

    let url = '/account/project_usernames',
        data = {
            project_id
        };

    try{
        let res = await axios.get(url,{params:data});
        return res;
    }catch(err){
        console.log(err);
    }

    return null;
}

project.getPublicPermissions = async function(tid) {
    const url = 'project/public_permission';
    const params = {
        tenant_id: tid,
    };
    try {
        const res = await axios.post(url, params);
        return res ? res.data : null;
    } catch (err) {
        console.log(err);
    }

    return null;
}

export default project;
